class TestimonialsSlider {

    constructor(section){

        this.section = section;
        this.track = section.querySelector('.testimonials-track');

        if(!this.track) return;

        this.cards = [...this.track.children];
this.isTouching = false;
        this.prev = section.querySelector('.testimonial-arrow.prev');
        this.next = section.querySelector('.testimonial-arrow.next');
        this.dots = section.querySelector('.testimonial-dots');

        this.index = 0;
        this.isScrolling = false;
        this.speed = Number(section.dataset.autoplaySpeed) || 5;
        this.autoplay = section.dataset.autoplay === "true";

        this.timer = null;

        this.visible = this.getVisible();

        this.setup();

        this.events();

        this.buildDots();

        this.go(this.visible,false);

        if(this.autoplay){
            this.start();
        }

    }


    getVisible(){

        if(window.innerWidth < 750) return 1;

        if(window.innerWidth < 991) return 2;

        return 4;

    }


    get step(){

        return this.track.children[0].offsetWidth + 24;

    }


   setup(){

    this.originalLength = this.cards.length;


    let before = this.cards
        .slice(-this.visible)
        .map(card=>card.cloneNode(true));


    let after = this.cards
        .slice(0,this.visible)
        .map(card=>card.cloneNode(true));


    this.track.prepend(...before);

    this.track.append(...after);


    this.all = [...this.track.children];


    this.index = this.visible;

}


    go(index,smooth=true){

    this.track.scrollTo({

        left:index*this.step,

        behavior:smooth ? "smooth" : "auto"

    });


    this.index=index;

    this.updateDots();

}


nextSlide(){

    this.index++;

    this.appendNext();

    this.go(this.index);

}



prevSlide(){

    if(this.index <= 0){

        this.prependPrev();

        this.index = 1;

    }


    this.index--;

    this.go(this.index);

}

prependPrev(){

    let prevIndex =
    (this.cards.length - 1) - 
    ((this.cards.length - 1 - this.index) % this.cards.length);


    let clone =
    this.cards[prevIndex].cloneNode(true);


    this.track.prepend(clone);


    this.track.scrollLeft += this.step;

}



    buildDots(){

    if(!this.dots) return;


    this.dots.innerHTML="";


    this.cards.forEach((card,i)=>{


        let dot=document.createElement("button");


        dot.className="testimonial-dot";


        dot.onclick=()=>{

            this.index=i;

            this.go(this.index);

        };


        this.dots.appendChild(dot);


    });


}



   updateDots(){

    if(!this.dots) return;


    let activeIndex = this.index % this.cards.length;


    [...this.dots.children].forEach((dot,i)=>{

        dot.classList.toggle(
            "active",
            i === activeIndex
        );

    });

}



    start(){

    this.stop();


    if(!this.autoplay || this.isTouching) return;


    this.timer=setInterval(()=>{


        if(this.isTouching) return;


        this.nextSlide();


    },this.speed*1000);

}



    stop(){

        clearInterval(this.timer);

    }



    events(){


        this.next?.addEventListener(
            "click",
            ()=>this.nextSlide()
        );


        this.prev?.addEventListener(
            "click",
            ()=>this.prevSlide()
        );



        this.section.addEventListener(
            "mouseenter",
            ()=>this.stop()
        );


        this.section.addEventListener(
            "mouseleave",
            ()=>this.start()
        );

        this.track.addEventListener("scrollend",()=>{

    let position =
    Math.round(this.track.scrollLeft / this.step);


    this.go(position,false);

});



        

      this.track.addEventListener("scroll",()=>{


    if(this.isScrolling) return;


    let end =
    this.track.scrollLeft + this.track.clientWidth >= 
    this.track.scrollWidth - this.step;


    if(end){

        this.appendNext();

    }


});

this.track.addEventListener("touchstart",()=>{

    this.isTouching = true;

    this.stop();

});


this.track.addEventListener("touchend",()=>{

    this.isTouching = false;

    setTimeout(()=>{

        if(this.autoplay){

            this.start();

        }

    },800);

});


    }

   appendNext(){

    let nextIndex = this.index % this.cards.length;


    let clone = this.cards[nextIndex].cloneNode(true);


    this.track.appendChild(clone);


}

}



function initTestimonials(){

    document.querySelectorAll(
        ".testimonials-slider"
    ).forEach(section=>{

        if(section.dataset.loaded) return;


        section.dataset.loaded=true;


        new TestimonialsSlider(section);


    });

}



document.addEventListener(
    "DOMContentLoaded",
    initTestimonials
);


document.addEventListener(
    "shopify:section:load",
    initTestimonials
);